/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetIssueTypesParams, SupportIssueResponse } from './api.schemas';

import { api } from '../util/http';

export const getIssueTypes = (params?: GetIssueTypesParams, signal?: AbortSignal) => {
  return api<SupportIssueResponse[]>({ url: `/api/issue-types`, method: 'GET', params, signal });
};

export const getGetIssueTypesQueryKey = (params?: GetIssueTypesParams) => {
  return [`/api/issue-types`, ...(params ? [params] : [])] as const;
};

export const getGetIssueTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof getIssueTypes>>,
  TError = unknown,
>(
  params?: GetIssueTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssueTypes>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIssueTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIssueTypes>>> = ({ signal }) =>
    getIssueTypes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIssueTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIssueTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getIssueTypes>>>;
export type GetIssueTypesQueryError = unknown;

export function useGetIssueTypes<
  TData = Awaited<ReturnType<typeof getIssueTypes>>,
  TError = unknown,
>(
  params: undefined | GetIssueTypesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssueTypes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssueTypes>>,
          TError,
          Awaited<ReturnType<typeof getIssueTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIssueTypes<
  TData = Awaited<ReturnType<typeof getIssueTypes>>,
  TError = unknown,
>(
  params?: GetIssueTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssueTypes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIssueTypes>>,
          TError,
          Awaited<ReturnType<typeof getIssueTypes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIssueTypes<
  TData = Awaited<ReturnType<typeof getIssueTypes>>,
  TError = unknown,
>(
  params?: GetIssueTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssueTypes>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetIssueTypes<
  TData = Awaited<ReturnType<typeof getIssueTypes>>,
  TError = unknown,
>(
  params?: GetIssueTypesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIssueTypes>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIssueTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
